import classNames from "classnames";
export var defaultTextInputRootClasses = classNames('__text_input', '__text_input_variant');
export var defaultTextAreaRootClasses = classNames('__text_input_area', '__text_input_variant');
export var defaultTopClasses = classNames('__input__content_top');
export var defaultCenterClasses = classNames('__input__content_center');
export var defaultBottomClasses = classNames('__input__content_bottom');
export var defaultLeftClasses = classNames('__input__content_left');
export var defaultInputClasses = classNames('__input__content_input');
export var defaultRightClasses = classNames('__input__content_right');
export var defaultItemClasses = classNames('__input__content_item');
export var LabelSize = {
    small: 'x-small',
    normal: 'xx-small',
    large: 'xx-small',
};
export var HintSize = {
    small: 'x-small',
    normal: 'x-small',
    large: 'x-small',
};
export var PrefixSize = {
    small: 'x-small',
    normal: 'xx-small',
    large: 'xx-small',
};
export var SuffixSize = {
    small: 'x-small',
    normal: 'xx-small',
    large: 'xx-small',
};
export var ButtonItemProps = {
    filled: {
        hoverColor: 'surface-1',
    },
};
export var IconSize = {
    small: 14,
    normal: 16,
    large: 18,
};
